import React, { useState, useEffect, useMemo } from 'react';
import SwiperCore, { Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useStateContext } from '../../context/StateContext';

import { useGetMoviePopularQuery } from '../../services/movieApi';
import HeroSlideItem from './HeroSlideItem';
import { IoMdClose } from 'react-icons/io';

const HeroSlide = () => {
  const { modal, setModal, movieTrailer } = useStateContext();
  const { data: moviePopuler } = useGetMoviePopularQuery();
  const sortedMovie = moviePopuler?.results?.slice(1, 4);
  SwiperCore.use([Autoplay]);
  return (
    <div className="relative w-full h-full">
      <Swiper
        modules={[Autoplay]}
        grabCursor={true}
        spaceBetween={0}
        slidesPerView={1}
        autoplay={{ delay: 3000 }}
      >
        {sortedMovie?.map((item, i) => (
          <SwiperSlide key={i}>
            {({ isActive }) => (
              <HeroSlideItem
                item={item}
                className={`${isActive ? 'active' : ''}`}
              />
            )}
          </SwiperSlide>
        ))}
      </Swiper>
      {modal && (
        <div className="w-full h-full fixed top-0 left-0 bg-black/40 z-30">
          <div className="w-1/2 h-1/2 fixed top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 bg-gray-900 drop-shadow-xl z-40 flex flex-col p-8">
            <IoMdClose
              onClick={() => setModal(false)}
              className="w-6 h-6 z-50 text-white cursor-pointer absolute top-2 right-1"
            />
            <iframe
              src={`https://www.youtube.com/embed/${movieTrailer?.results[0]?.key}`}
              width="100%"
              height={'500px'}
              title="trailerMovie"
            ></iframe>
          </div>
        </div>
      )}
    </div>
  );
};

export default HeroSlide;
